module.exports = __webpack_public_path__ + "img/14-1.7942a2e7.png";